import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon/arrow_down_filling.png';

const _withScopeId = n => (_pushScopeId("data-v-b0493c02"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "futures-view"
};
const _hoisted_2 = {
  style: {
    "height": "53px"
  }
};
const _hoisted_3 = {
  class: "trade-options"
};
const _hoisted_4 = {
  class: "options-l"
};
const _hoisted_5 = {
  class: "trade-btn-area"
};
const _hoisted_6 = {
  class: "f-entrust-area"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
}, null, -1));

const _hoisted_8 = {
  key: 0,
  class: "futures-price-best",
  style: {
    "color": "black"
  }
};
const _hoisted_9 = {
  style: {
    "color": "#919497",
    "font-weight": "700",
    "padding": "0 10px"
  }
};
const _hoisted_10 = {
  class: "futures-text"
};
const _hoisted_11 = {
  class: "futures-num"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#919497",
    "font-weight": "700",
    "padding": "0 10px"
  }
}, "USDT", -1));

const _hoisted_13 = {
  style: {
    "padding": "5px 0 12px 0"
  }
};
const _hoisted_14 = {
  class: "options-r"
};
const _hoisted_15 = {
  class: "trade-table-item",
  style: {
    "color": "#acafb3",
    "margin-bottom": "20px",
    "font-size": "12px"
  }
};
const _hoisted_16 = {
  class: "table-item-l"
};
const _hoisted_17 = {
  class: "table-item-r"
};
const _hoisted_18 = {
  class: "futures-price-title"
};
const _hoisted_19 = {
  style: {
    "font-size": "12px",
    "color": "#ACAFB3",
    "line-height": "100%",
    "margin-top": "2px"
  }
};
const _hoisted_20 = {
  style: {
    "margin-bottom": "10px",
    "padding": "0 0 10px 16px",
    "display": "flex",
    "align-items": "center",
    "background-color": "var(--bg-color)"
  }
};
const _hoisted_21 = {
  style: {
    "width": "53%",
    "margin-right": "3%"
  }
};
const _hoisted_22 = {
  style: {
    "min-height": "calc(100vh - 190.7px)",
    "padding": "1px 10px",
    "background-color": "var(--atbg-color)"
  }
};
const _hoisted_23 = {
  style: {
    "min-height": "calc(100vh - 190.7px)",
    "padding": "1px 10px",
    "background-color": "var(--atbg-color)"
  }
};
const _hoisted_24 = {
  style: {
    "min-height": "calc(100vh - 190.7px)",
    "padding": "1px 10px",
    "background-color": "var(--atbg-color)"
  }
};
const _hoisted_25 = {
  class: "search"
};
const _hoisted_26 = {
  class: "set-popup"
};
const _hoisted_27 = {
  class: "header"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "padding": "0 16px"
  }
};
const _hoisted_30 = {
  style: {
    "padding": "5px 16px 18px 16px"
  }
};
const _hoisted_31 = {
  class: "set-popup"
};
const _hoisted_32 = {
  class: "header"
};
const _hoisted_33 = {
  class: "title"
};
const _hoisted_34 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "align-items": "center",
    "padding": "0 16px"
  }
};
const _hoisted_35 = {
  style: {
    "padding": "5px 16px 18px 16px"
  }
};
const _hoisted_36 = {
  style: {
    "max-height": "80vh",
    "overflow": "scroll"
  }
};
import TradeOptionHeader from '@/components/TradeOptionHeader.vue';
import DataBlock from '@/components/DataBlock.vue';
import EntrustSelect from '@/components/EntrustSelect.vue';
import CustomTab from '@/components/CustomTab.vue';
import CustomPopupList from '@/components/CustomPopupList.vue';
import TradeProductItem from '@/components/TradeProductItem.vue';
import ContractItem from '@/components/ContractItem.vue';
import EmptyLogin from '@/components/EmptyLogin.vue';
import { getUserAsset, futureCloseAll, contractList, setSlTp, futureChild, futureOpen, futureClose } from '@/apis';
import BigNumber from "bignumber.js"; // import { exType } from '@/util/type'
// import monent from 'moment'

import { useI18n } from "vue-i18n";
import { fmtNumber } from '@/util';
import { SearchOutlined } from '@ant-design/icons-vue'; // import { useWindowSize } from '@vant/use'

import { ref, watch, onActivated, onDeactivated, computed, onUpdated } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import store from '@/store'; // import moment from 'moment'

import { Toast } from 'vant';
import 'vant/es/toast/style';
import { Dialog } from 'vant';
import 'vant/es/dialog/style';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
export default {
  __name: 'CommoditiesView',
  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    assetUsdt: {
      type: Number,
      default: 0
    }
  },
  emits: ["tabbarShowChange", "tabbarIndexChange", "assetInit"],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const isLight = ref(true);
    const {
      t
    } = useI18n();
    const router = useRouter();
    const route = useRoute();
    const activeIndex = ref(0);
    const dataList = ref({});
    const assetUsdt = ref(0);
    const assetList = ref({});
    const searchValue = ref('');
    const coinArr = computed(() => {
      var arr = [];
      store.state.marketCommoditiesKey.forEach(item => {
        if (item.indexOf(searchValue.value.toUpperCase()) != -1) arr.push(item);
      });
      return arr;
    }); // 合约

    const reo = ref('0.00');
    const caLoading = ref(false);
    let currentTimer = null;
    const totalRate = ref(0);
    const isRate = ref(false);
    const marks = ref({
      0: '0%',
      25: '25%',
      50: '50%',
      75: '75%',
      100: '100%'
    });
    const fee = ref(0);
    const uProfit = ref('');
    const uDeficit = ref('');
    let setId = null;
    const setLoading = ref(false);
    const setShow = ref(false);
    const setLoading1 = ref(false);
    const setShow1 = ref(false);
    const amount = ref('');
    const contractInitLoading = ref(false);
    const tradeType = ref(0); // 0 买入 1 卖出

    const entrustType = ref(1); // 委托类型 0 限价委托 1 市场委托

    const entrustPrice = ref(0); // 限价委托

    const entrustNum = ref(null);
    const numInput = ref(false);
    const totalPrice = ref(null);
    const totalInput = ref(false);
    const deficit = ref(null);
    const profit = ref(null);
    const maxNum = ref(0);
    const minNum = ref(0);
    const decimal = ref(2);
    const contractShow = ref(false);
    const multiple = [{
      name: '10X'
    }, {
      name: '30X'
    }, {
      name: '50X'
    }, {
      name: '100X'
    }, {
      name: '125X'
    }, {
      name: '200X'
    }];
    const multipleNum = [10, 30, 50, 100, 125, 200];
    const multipleIndex = ref(1);
    const multiplShow = ref(false);
    const contractKey = ref('');
    const currentList = ref([]);
    let currentPage = 1;
    const currentLoading = ref(false);
    const currentFinished = ref(true);
    const holdList = ref([]);
    let holdPage = 1;
    const holdLoading = ref(false);
    const holdFinished = ref(true);
    const openList = ref([]);
    let openPage = 1;
    const openLoading = ref(false);
    const openFinished = ref(true); // 秒合约
    // const { height } = useWindowSize()
    // const oldHeight = height.value
    // const waitShow = ref(false)
    // const currentId = ref(0)
    // const waitForm = ref({
    //   key: '',
    //   side: '',
    //   num: '',
    //   last: '',
    //   profit: '',
    //   endTime: '',
    //   status: ''
    // })
    // const waitLoading = ref(false)
    // let heightWatch = null

    let dataTimer = null;
    let updateNewData = null;
    const all = ref(0);
    onUpdated(() => {
      if (isLight.value != Boolean(localStorage.getItem('isLight') == 'true')) isLight.value = Boolean(localStorage.getItem('isLight') == 'true');
    });

    const tradeTypeChange = index => {
      tradeType.value = index;
      entrustNum.value = null;
      totalPrice.value = null;
      totalRate.value = 0;
    };

    const rateChange = value => {
      const total = Number(BigNumber(assetUsdt.value).multipliedBy(value).dividedBy(100).toFixed(8));
      const feeNum = BigNumber(assetUsdt.value).multipliedBy(fee.value).multipliedBy(multipleNum[multipleIndex.value]).toNumber();
      const max = BigNumber(assetUsdt.value).minus(feeNum).toNumber();

      if (total < 0) {
        totalPrice.value = 0;
      } else if (total > max) {
        totalPrice.value = max;
      } else {
        totalPrice.value = total;
      }

      if (totalPrice.value > 0) {
        if (entrustType.value === 1) {
          const price = store.state.market[contractKey.value] ? Number(store.state.market[contractKey.value].last) : 0;
          entrustNum.value = Number(BigNumber(totalPrice.value).dividedBy(price).toFixed(8));
        } else {
          if (entrustPrice.value > 0) {
            entrustNum.value = Number(BigNumber(totalPrice.value).dividedBy(entrustPrice.value).toFixed(8));
          }
        }
      }
    };

    watch(() => contractKey.value, async () => {
      if (store.state.marketCommodities[contractKey.value]) {
        decimal.value = store.state.marketCommodities[contractKey.value].decimal;
        entrustNum.value = null;
        totalPrice.value = null;
        entrustPrice.value = store.state.market[contractKey.value].last;
        deficit.value = null;
        profit.value = null;
      }

      maxNum.value = store.state.marketInfo[contractKey.value].maxAmount;
      minNum.value = store.state.marketInfo[contractKey.value].minAmount;
    });
    watch([entrustNum], () => {
      if (numInput.value) {
        let dNum = 8;

        if (store.state.marketCommodities[contractKey.value] && store.state.marketCommodities[contractKey.value].decimal > 8) {
          dNum = store.state.marketCommodities[contractKey.value].decimal;
        }

        if (entrustType.value === 0 && entrustPrice.value) {
          totalPrice.value = Number(BigNumber(entrustPrice.value).multipliedBy(entrustNum.value).toFixed(dNum));
        }

        if (entrustType.value) {
          const price = dataList.value[contractKey.value] ? Number(dataList.value[contractKey.value].last) : 0;
          totalPrice.value = Number(BigNumber(price).multipliedBy(entrustNum.value).toFixed(dNum));
        }
      }

      if (entrustNum.value === null && totalPrice.value) {
        totalPrice.value = null;
      }
    });
    watch([entrustPrice], () => {
      let dNum = 8;

      if (store.state.marketCommodities[contractKey.value] && store.state.marketCommodities[contractKey.value].decimal > 8) {
        dNum = store.state.marketCommodities[contractKey.value].decimal;
      }

      if (entrustType.value === 0 && entrustPrice.value > 0 && totalPrice.value > 0) {
        entrustNum.value = Number(BigNumber(totalPrice.value).dividedBy(entrustPrice.value).toFixed(dNum));
      }
    });
    watch([totalPrice], () => {
      if (totalInput.value || numInput.value) {
        const feeNum = BigNumber(assetUsdt.value).multipliedBy(fee.value).multipliedBy(multipleNum[multipleIndex.value]).toNumber();
        const max = BigNumber(assetUsdt.value).minus(feeNum).toNumber();

        if (totalPrice.value < 0) {
          totalRate.value = 0;
        } else if (totalPrice.value > max) {
          totalRate.value = 100;
        } else {
          totalRate.value = Number(BigNumber(totalPrice.value).dividedBy(max).multipliedBy(100).toFixed(0));
        }
      }

      if (totalInput.value) {
        let dNum = 8;

        if (store.state.marketCommodities[contractKey.value] && store.state.marketCommodities[contractKey.value].decimal > 8) {
          dNum = store.state.marketCommodities[contractKey.value].decimal;
        }

        if (entrustPrice.value && entrustType.value === 0) {
          entrustNum.value = Number(BigNumber(totalPrice.value).dividedBy(entrustPrice.value).toFixed(dNum));
        }

        if (entrustType.value) {
          const price = store.state.market[contractKey.value] ? Number(store.state.market[contractKey.value].last) : 0;

          if (price > 0) {
            entrustNum.value = Number(BigNumber(totalPrice.value).dividedBy(price).toFixed(dNum));
          }
        }
      }

      if (totalPrice.value === null && entrustNum.value) {
        entrustNum.value = null;
      }
    });

    const setEmit = id => {
      setId = id;
      const index = currentList.value.findIndex(item => item.id === id);
      uDeficit.value = currentList.value[index]?.sl;
      uProfit.value = currentList.value[index]?.tp;
      setShow.value = true;
    };

    const setEmit1 = (id, number) => {
      setId = id;
      all.value = number;
      amount.value = number;
      setShow1.value = true;
    };

    watch(amount, () => {
      var pattern = /^[0-9]+(\.[0-9]{0,8})?$/;

      if (amount.value != '' && !pattern.test(amount.value)) {
        amount.value = Math.floor(Number((amount.value + '').replace(/[a-zA-Z]+/g, "")) * 10000000) / 10000000;
      }
    });

    const setProfit = async () => {
      setLoading.value = true;
      const res = await setSlTp({
        'id': setId,
        stopLoss: Number(uDeficit.value),
        takeProfit: Number(uProfit.value)
      });
      setLoading.value = false;

      if (res.code === 200) {
        setShow.value = false;
        Toast({
          message: t('setSuccess'),
          position: 'bottom'
        });
        currentInit();
        return;
      }

      if (res.code === 501) {
        Toast({
          message: t('indicesNotAllowSet'),
          position: "bottom"
        });
        return;
      }

      Toast({
        message: res.msg ? res.msg : t('setError'),
        position: 'bottom'
      });
    };

    const routerName = name => {
      if (store.state.token === '') {
        router.push({
          name: 'login'
        });
        return;
      }

      router.push({
        name: name
      });
    };

    const fmtListArray = list => {
      dayjs.extend(utc);
      dayjs.extend(timezone);
      return list.map(item => {
        var price = item.openPrice;

        if (item.state == 0 && tabIndex.value == 0) {
          price = item.limitPrice;
        }

        return {
          id: item.id,
          name: item.marketName,
          multiple: item.multiple,
          side: item.side,
          type: item.type,
          time: dayjs(item.createdAt * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
          num: item.num,
          warrant: fmtNumber(item.amount),
          fee: item.fee,
          profit: item.profit,
          status: item.state,
          openPrice: price,
          sl: item.stopLoss,
          //止损
          tp: item.takeProfit,
          // 止盈
          close: item.closeType,
          last: item.closePrice,
          closeTime: dayjs(item.closeTime * 1000).tz("America/New_York").format("YYYY-MM-DD HH:mm:ss"),
          symbol: item.marketSymbol,
          mergeKey: item.mergeKey,
          orderNum: item.orderNum,
          openNum: item.num ? item.num : item.openNum,
          icon: item.icon ? process.env.VUE_APP_IMG + item.icon : ''
        };
      });
    };

    const assetInit = async () => {
      const res = await getUserAsset({
        platform: 1
      });

      if (res.code === 200 && res.data) {
        res.data.forEach(item => {
          const num = item.active ? item.active : 0;
          assetList.value[item.marketName] = num;

          if (item.marketName === 'USDT') {
            assetUsdt.value = num;
          }
        });
      }
    };

    const currentInit = async () => {
      currentPage = 1;
      const res = await contractList('order/open', {
        mt: 1
      });

      if (res.code === 200 && res.data) {
        currentList.value = fmtListArray(res.data.list);

        if (res.data.count > currentList.value.length) {
          currentFinished.value = false;
        }
      }
    };

    const isShowFutureChild = ref(false);
    const futureChildList = ref([]);

    const showFutureChild = mergeKey => {
      isShowFutureChild.value = true;
      getFutureChild(mergeKey);
    };

    const getFutureChild = async mergeKey => {
      const res = await futureChild({
        'mergeKey': mergeKey
      });

      if (res.code === 200 && res.data) {
        futureChildList.value = fmtListArray(res.data);
        futureChildList.value.forEach(item => {
          item.status = 0;
        });
      }
    };

    const openInit = async () => {
      openPage = 1;
      const res = await contractList('open/history', {
        mt: 1
      });

      if (res.code === 200 && res.data.list) {
        openList.value = fmtListArray(res.data.list);

        if (res.data.count > openList.value.length) {
          openFinished.value = false;
        }
      }
    };

    const holdInit = async () => {
      holdPage = 1;
      const res = await contractList('close/history', {
        mt: 1
      });

      if (res.code === 200 && res.data.list) {
        holdList.value = fmtListArray(res.data.list);

        if (res.data.count > holdList.value.length) {
          holdFinished.value = false;
        }
      }
    };

    const tabIndex = ref(0);

    const contractTabChange = tab => {
      tabIndex.value = tab;

      if (tab === 1) {
        openInit();
      } else {
        holdInit();
      }
    };

    const pageInit = async () => {
      if (store.state.token !== '') assetInit();

      if (contractKey.value === '' && store.state.marketCommoditiesKey.length > 0) {
        contractKey.value = store.state.marketCommoditiesKey[0];
      }

      if (store.state.token !== '') {
        currentInit();
        holdInit();
      }
    }; //解决刷新的时候没有数据展示


    watch(() => store.state.marketCommoditiesKey, () => {
      contractKey.value = store.state.marketCommoditiesKey[0];
    });

    const dataChange = () => {
      dataTimer = setInterval(() => {
        dataList.value = { ...store.state.market
        };
      }, 1200);
    };

    const goToKline = () => {
      if (contractKey.value === '') {
        Toast({
          message: t('tryAgain'),
          position: 'bottom'
        });
        return;
      }

      router.push({
        name: 'kline1',
        query: {
          key: contractKey.value,
          type: 'contract'
        }
      });
    };

    onActivated(() => {
      const paramActive = Number(route.query.active);

      if (paramActive === 1) {
        activeIndex.value = paramActive;
        emit("tabbarIndexChange", 3);
      }

      if (route.query.type && props.activeIndex == 0) {
        switch (route.query.type) {
          case '1':
            tradeType.value = 0;
            break;

          case '2':
            tradeType.value = 1;
            break;
        }
      }

      if (route.query.key) {
        contractKey.value = route.query.key;
      } //   heightWatch = watch([height], () => {
      //     let show = true
      //     if (oldHeight - height.value > 120) {
      //       show = false
      //     }
      //     emit("tabbarShowChange", show)
      //   })


      pageInit().finally(() => {
        if (store.state.token !== '') {
          updateNewData = setInterval(() => {
            currentInit(); // assetInit()

            emit('assetInit');
          }, 10000);
        } else {
          reo.value = '0.00';
        }
      });
      dataList.value = { ...store.state.market
      };
      dataChange();
    });
    onDeactivated(() => {
      clearInterval(dataTimer);
      clearInterval(currentTimer);
      clearInterval(updateNewData);
    });

    const contractRefresh = () => {
      contractInitLoading.value = true;
      pageInit().finally(() => {
        contractInitLoading.value = false;
      });
    };

    const currentLoad = async () => {
      const page = currentPage + 1;
      currentLoading.value = true;
      const res = await contractList('order/open', {
        page: page,
        mt: 1
      });
      currentLoading.value = false;

      if (res.code === 200 && res.data) {
        const list = fmtListArray(res.data);
        currentList.value = [...currentList.value, ...list];

        if (currentList.value.length >= res.data.legnth) {
          currentFinished.value = true;
        }

        currentPage += 1;
      }
    };

    const openLoad = async () => {
      const page = openPage + 1;
      openLoading.value = true;
      const res = await contractList('open/history', {
        page: page,
        mt: 1
      });
      openLoading.value = false;

      if (res.code === 200 && res.data && res.data.list) {
        const list = fmtListArray(res.data.list);
        openList.value = [...openList.value, ...list];

        if (openList.value.length >= res.data.total) {
          openFinished.value = true;
        }

        openPage += 1;
      }
    };

    const holdLoad = async () => {
      const page = holdPage + 1;
      holdLoading.value = true;
      const res = await contractList('close/history', {
        page: page,
        mt: 1
      });
      holdLoading.value = false;

      if (res.code === 200 && res.data && res.data.list) {
        const list = fmtListArray(res.data.list);
        holdList.value = [...holdList.value, ...list];

        if (holdList.value.length >= res.data.total) {
          holdFinished.value = true;
        }

        holdPage += 1;
      }
    };

    onDeactivated(() => {
      //   heightWatch()
      clearInterval(updateNewData);
    });

    const entrustChange = index => {
      if (index === 0) {
        entrustPrice.value = dataList.value[contractKey.value] ? Number(dataList.value[contractKey.value].last) : 0;
      }

      entrustType.value = index;
    };

    const tradeCommit = () => {
      let beforeClose = null;

      if (store.state.token === '') {
        router.push({
          name: 'login'
        });
        return;
      }

      if (entrustType.value === 0) {
        if (!entrustPrice.value) {
          Toast({
            message: t('entrustPriceTip'),
            position: 'bottom'
          });
          return;
        }
      }

      if (!totalPrice.value) {
        Toast({
          message: t('tradePriceTip'),
          position: 'bottom'
        });
        return;
      }

      const feeNum = BigNumber(assetUsdt.value).multipliedBy(fee.value).multipliedBy(multipleNum[multipleIndex.value]).toNumber();
      const max = BigNumber(assetUsdt.value).minus(feeNum).toNumber();

      if (totalPrice.value > max) {
        Toast({
          message: t('balanceTip'),
          position: 'bottom'
        });
        return;
      }

      if (totalPrice.value < 100) {
        Toast({
          message: t('tradeMin100'),
          position: 'bottom'
        });
        return;
      }

      const data = {
        marketId: store.state.marketCommodities[contractKey.value].id,
        amount: Number(totalPrice.value),
        side: Number(tradeType.value),
        multiple: multipleNum[multipleIndex.value]
      };

      if (entrustType.value) {
        data['type'] = 0;
      } else {
        data['type'] = 1;
        data['price'] = Number(entrustPrice.value);
      }

      if (profit.value) {
        data['takeProfit'] = Number(profit.value);
      }

      if (deficit.value) {
        data['stopLoss'] = Number(deficit.value);
      }

      beforeClose = action => {
        return new Promise(resolve => {
          if (action === 'confirm') {
            futureOpen(data).then(res => {
              if (res.code == 501) {
                resolve(false);
                Toast({
                  message: t('indicesNotAllowOpen'),
                  position: 'bottom'
                });
                return;
              }

              if (res.code !== 200) {
                resolve(false);
                Toast({
                  message: res.msg !== '' ? res.msg : t('tradeError'),
                  position: 'bottom'
                });
                return;
              }

              Toast({
                message: t('tradeSuccess'),
                position: 'bottom'
              });
              resolve(true);
              pageInit().finally(() => {
                entrustPrice.value = null;
                entrustNum.value = null;
                totalPrice.value = null;
                deficit.value = null;
                profit.value = null;
              });
            });
          } else {
            resolve(true);
          }
        });
      };

      Dialog.confirm({
        title: t('tip'),
        message: t('tradeConfirm'),
        cancelButtonText: t('cancelText'),
        confirmButtonText: t('confirmText'),
        beforeClose
      }).catch(() => {});
    };

    const getContractUp = () => {
      const key = contractKey.value;
      return dataList.value[key] ? dataList.value[key].up : true;
    };

    const getContractNum = name => {
      const key = contractKey.value;
      return dataList.value[key] ? Number(dataList.value[key][name]).toFixed(decimal.value) : '0.00';
    };

    const getContractStr = name => {
      const key = contractKey.value;
      return store.state.marketCommodities[key] ? store.state.marketCommodities[key][name] : '-';
    };

    const closeAll = () => {
      if (currentList.value.length > 0) {
        caLoading.value = true;
        futureCloseAll({
          mt: 1
        }).then(res => {
          if (res.code === 501) {
            Toast({
              message: t('indicesNotAllowClose'),
              position: "bottom"
            });
            return;
          }

          if (res.code !== 200) {
            Toast({
              message: res.msg !== '' ? res.msg : t('tradeError'),
              position: 'bottom'
            });
            return;
          }

          Toast({
            message: res.msg,
            position: 'bottom'
          });
          pageInit();
        }).finally(() => {
          caLoading.value = false;
        });
      }
    };

    const closeOrder = async () => {
      setLoading1.value = true;
      futureClose({
        'id': setId,
        'amount': Number(amount.value)
      }).then(res => {
        if (res.code === 501) {
          Toast({
            message: t('indicesNotAllowClose'),
            position: "bottom"
          });
          setShow1.value = false;
          setLoading1.value = false;
          return;
        }

        if (res.code !== 200) {
          Toast({
            message: res.msg ? res.msg : t('unwindError'),
            position: "bottom"
          });
          pageInit();
          setShow1.value = false;
          setLoading1.value = false;
          return;
        }

        Toast({
          message: t('unwindSuccess'),
          position: "bottom"
        });
        pageInit();
        setLoading1.value = false;
        setShow1.value = false;
      });
    };

    return (_ctx, _cache) => {
      const _component_van_button = _resolveComponent("van-button");

      const _component_a_input_number = _resolveComponent("a-input-number");

      const _component_a_input = _resolveComponent("a-input");

      const _component_a_slider = _resolveComponent("a-slider");

      const _component_van_list = _resolveComponent("van-list");

      const _component_van_empty = _resolveComponent("van-empty");

      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");

      const _component_van_action_sheet = _resolveComponent("van-action-sheet");

      const _component_van_popup = _resolveComponent("van-popup");

      const _component_a_modal = _resolveComponent("a-modal");

      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_pull_refresh, {
        modelValue: contractInitLoading.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => contractInitLoading.value = $event),
        onRefresh: contractRefresh,
        "pulling-text": _unref(t)('pulling'),
        "loosing-text": _unref(t)('loosing'),
        "loading-text": _unref(t)('loading'),
        disabled: isRate.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(TradeOptionHeader, {
          "trade-name": _unref(store).state.marketCommodities[contractKey.value]?.name,
          "trend-num": getContractNum('growth'),
          onShowProudct: _cache[0] || (_cache[0] = $event => contractShow.value = true),
          up: getContractUp(),
          onKline: goToKline
        }, null, 8, ["trade-name", "trend-num", "up"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
          color: tradeType.value ? '#F7F6FB' : '#04AC92',
          block: "",
          onClick: _cache[1] || (_cache[1] = $event => tradeTypeChange(0)),
          style: _normalizeStyle({
            '--van-button-border-radius': '2px',
            color: tradeType.value ? '#919497' : 'white',
            width: '50%',
            clipPath: 'polygon(0 0, 100% 0, 95% 100%, 0 100%)',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '38px'
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('toBuy')), 1)]),
          _: 1
        }, 8, ["color", "style"]), _createVNode(_component_van_button, {
          color: tradeType.value ? '#D04C64' : '#F7F6FB',
          block: "",
          onClick: _cache[2] || (_cache[2] = $event => tradeTypeChange(1)),
          style: _normalizeStyle({
            '--van-button-border-radius': '2px',
            color: tradeType.value ? 'white' : '#919497',
            width: '50%',
            clipPath: 'polygon(5% 0, 100% 0, 100% 100%, 0 100%)',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '38px'
          })
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('toSell')), 1)]),
          _: 1
        }, 8, ["color", "style"])]), _createElementVNode("div", _hoisted_6, [_createVNode(EntrustSelect, {
          "entrust-type": entrustType.value,
          onEntrustChange: entrustChange,
          style: {
            "width": "65%",
            "color": "var(--text-color)"
          },
          "popover-w": "calc((100vw - 32px) * 0.3575)",
          size: 0
        }, null, 8, ["entrust-type"]), _createElementVNode("div", {
          class: "multiple",
          onClick: _cache[3] || (_cache[3] = $event => multiplShow.value = true),
          style: {
            "width": "30%"
          }
        }, [_createElementVNode("span", null, _toDisplayString(multiple[multipleIndex.value].name), 1), _hoisted_7])]), entrustType.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(t)('optimal')), 1)) : (_openBlock(), _createBlock(_component_a_input_number, {
          key: 1,
          class: "entrust-price-input",
          type: "number",
          value: entrustPrice.value,
          "onUpdate:value": _cache[4] || (_cache[4] = $event => entrustPrice.value = $event),
          min: "0.01",
          placeholder: _unref(t)('price'),
          style: _normalizeStyle({
            '--entrust-focus': tradeType.value ? '#D04C64' : '#04AC92'
          }),
          precision: 8
        }, null, 8, ["value", "placeholder", "style"])), _withDirectives(_createElementVNode("div", {
          class: "trade-num",
          style: _normalizeStyle({
            '--trade-num-focus': tradeType.value ? '#D04C64' : '#04AC92',
            marginTop: '10px'
          })
        }, [_createVNode(_component_a_input_number, {
          value: entrustNum.value,
          "onUpdate:value": _cache[5] || (_cache[5] = $event => entrustNum.value = $event),
          bordered: false,
          style: {
            "width": "100%",
            "font-size": "14px"
          },
          onBlur: _cache[6] || (_cache[6] = $event => numInput.value = false),
          placeholder: _unref(t)('number'),
          type: "number",
          precision: 8,
          min: "0",
          onFocus: _cache[7] || (_cache[7] = $event => numInput.value = true)
        }, null, 8, ["value", "placeholder"]), _createElementVNode("div", _hoisted_9, _toDisplayString(getContractStr('stock')), 1)], 4), [[_vShow, 0 == 1]]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", null, _toDisplayString(_unref(t)('useable')), 1), _createElementVNode("div", null, _toDisplayString(assetUsdt.value) + " USDT", 1)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_a_input, {
          class: "custom-a-input",
          value: profit.value,
          "onUpdate:value": _cache[8] || (_cache[8] = $event => profit.value = $event),
          style: {
            "width": "48%"
          },
          type: "number",
          placeholder: _unref(t)('tpPrice')
        }, null, 8, ["value", "placeholder"]), _createVNode(_component_a_input, {
          class: "custom-a-input",
          value: deficit.value,
          "onUpdate:value": _cache[9] || (_cache[9] = $event => deficit.value = $event),
          style: {
            "width": "48%",
            "margin": "8px 0"
          },
          placeholder: _unref(t)('slPrice'),
          type: "number"
        }, null, 8, ["value", "placeholder"])]), _createElementVNode("div", {
          class: "trade-num",
          style: _normalizeStyle({
            '--trade-num-focus': tradeType.value ? '#D04C64' : '#04AC92'
          })
        }, [_createVNode(_component_a_input_number, {
          value: totalPrice.value,
          "onUpdate:value": _cache[10] || (_cache[10] = $event => totalPrice.value = $event),
          bordered: false,
          style: {
            "width": "100%",
            "font-size": "14px"
          },
          placeholder: _unref(t)('tradeVol'),
          type: "number",
          precision: 8,
          min: "0",
          onBlur: _cache[11] || (_cache[11] = $event => totalInput.value = false),
          onFocus: _cache[12] || (_cache[12] = $event => totalInput.value = true)
        }, null, 8, ["value", "placeholder"]), _hoisted_12], 4)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_a_slider, {
          value: totalRate.value,
          "onUpdate:value": _cache[13] || (_cache[13] = $event => totalRate.value = $event),
          marks: marks.value,
          onChange: rateChange,
          onFocus: _cache[14] || (_cache[14] = $event => isRate.value = true),
          onBlur: _cache[15] || (_cache[15] = $event => isRate.value = false)
        }, null, 8, ["value", "marks"])]), _createVNode(_component_van_button, {
          color: tradeType.value ? '#D04C64' : '#04AC92',
          block: "",
          onClick: tradeCommit,
          style: {
            '--van-button-border-radius': '2px',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '40px'
          }
        }, {
          default: _withCtx(() => [tradeType.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode(_toDisplayString(_unref(t)('confirmToSell')), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode(_toDisplayString(_unref(t)('confirmToBuy')), 1)], 64))]),
          _: 1
        }, 8, ["color"])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(_unref(t)('price')), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(t)('number')), 1)]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
          return _createVNode(DataBlock, {
            key: index,
            class: "trade-table-item",
            bg: isLight.value ? 'rgba(251, 243, 241, .6)' : 'rgba(202,63,100,.2)',
            decimal: decimal.value,
            "color-l": "#EC234D",
            max: maxNum.value,
            min: minNum.value,
            price: getContractNum('last'),
            bottom: false,
            index: index - 1
          }, null, 8, ["bg", "decimal", "max", "min", "price", "index"]);
        }), 64)), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", {
          class: "big-num",
          style: _normalizeStyle({
            color: getContractUp() ? '#04AC92' : '#EC234D'
          })
        }, _toDisplayString(getContractNum('last')), 5), _createElementVNode("div", _hoisted_19, _toDisplayString(getContractNum('last')) + " USDT ", 1)]), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, index => {
          return _createVNode(DataBlock, {
            key: index,
            class: "trade-table-item",
            bg: isLight.value ? 'rgba(234, 249, 246, .6)' : 'rgba(37,167,80,.2)',
            decimal: decimal.value,
            "color-l": "#269B8B",
            max: maxNum.value,
            min: minNum.value,
            price: getContractNum('last'),
            bottom: true,
            index: index - 1
          }, null, 8, ["bg", "decimal", "max", "min", "price", "index"]);
        }), 64))])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createVNode(_component_van_button, {
          color: "#F08504",
          block: "",
          onClick: closeAll,
          loading: caLoading.value,
          style: {
            '--van-button-border-radius': '2px',
            fontWeight: 700,
            fontSize: '16px',
            '--van-button-default-height': '40px'
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('closeAll')), 1)]),
          _: 1
        }, 8, ["loading"])])]), _createVNode(CustomTab, {
          "tab-list": [_unref(t)('currentOrder'), _unref(t)('openRecord'), _unref(t)('closeRecord')],
          "offset-top": 46,
          onAllClick: _cache[19] || (_cache[19] = $event => routerName('COrder')),
          onChange: contractTabChange,
          ref: "tab"
        }, {
          tab1: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(EmptyLogin, {
            key: 0
          })) : currentList.value.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
            key: 1,
            "finished-text": _unref(t)('finished'),
            "loading-text": _unref(t)('loading'),
            loading: currentLoading.value,
            "onUpdate:loading": _cache[16] || (_cache[16] = $event => currentLoading.value = $event),
            finished: currentFinished.value,
            onLoad: currentLoad
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(currentList.value, item => {
              return _openBlock(), _createBlock(ContractItem, {
                key: item.id,
                name: item.name,
                multiple: item.multiple,
                sl: item.sl,
                tp: item.tp,
                icon: item.icon,
                status: item.status,
                side: item.side,
                type: item.type,
                time: item.time,
                "open-num": item.openNum,
                "open-price": item.openPrice,
                "hold-num": item.holdNum,
                last: dataList.value[item.symbol] ? dataList.value[item.symbol].last : '--',
                margin: item.margin,
                close: item.close,
                mergeKey: item.mergeKey,
                orderNum: item.orderNum,
                warrant: item.warrant,
                fee: item.fee,
                profit: item.profit,
                id: item.id,
                onInit: pageInit,
                onSet: setEmit,
                onSet1: setEmit1,
                onShowFutureChild: showFutureChild,
                "last-text": _unref(t)('lastPrice'),
                index: 0
              }, null, 8, ["name", "multiple", "sl", "tp", "icon", "status", "side", "type", "time", "open-num", "open-price", "hold-num", "last", "margin", "close", "mergeKey", "orderNum", "warrant", "fee", "profit", "id", "last-text"]);
            }), 128))]),
            _: 1
          }, 8, ["finished-text", "loading-text", "loading", "finished"])) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 2,
            description: _unref(t)('nothing')
          }, null, 8, ["description"]))])]),
          tab2: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(EmptyLogin, {
            key: 0
          })) : openList.value.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
            key: 1,
            "finished-text": _unref(t)('finished'),
            "loading-text": _unref(t)('loading'),
            loading: openLoading.value,
            "onUpdate:loading": _cache[17] || (_cache[17] = $event => openLoading.value = $event),
            finished: openFinished.value,
            onLoad: openLoad
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openList.value, item => {
              return _openBlock(), _createBlock(ContractItem, {
                key: item.id,
                name: item.name,
                multiple: item.multiple,
                sl: item.sl,
                tp: item.tp,
                icon: item.icon,
                status: item.status,
                side: item.side,
                type: item.type,
                time: item.time,
                "open-num": item.openNum,
                "open-price": item.openPrice,
                orderNum: item.orderNum,
                mergeKey: item.mergeKey,
                "hold-num": item.holdNum,
                last: item.last,
                margin: item.margin,
                warrant: item.warrant,
                fee: item.fee,
                onShowFutureChild: showFutureChild,
                profit: item.profit,
                id: item.id,
                close: item.close,
                "last-text": _unref(t)('unwindPrice'),
                "close-time": item.closeTime,
                index: 1
              }, null, 8, ["name", "multiple", "sl", "tp", "icon", "status", "side", "type", "time", "open-num", "open-price", "orderNum", "mergeKey", "hold-num", "last", "margin", "warrant", "fee", "profit", "id", "close", "last-text", "close-time"]);
            }), 128))]),
            _: 1
          }, 8, ["finished-text", "loading-text", "loading", "finished"])) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 2,
            description: _unref(t)('nothing')
          }, null, 8, ["description"]))])]),
          tab3: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_unref(store).state.token === '' ? (_openBlock(), _createBlock(EmptyLogin, {
            key: 0
          })) : holdList.value.length > 0 ? (_openBlock(), _createBlock(_component_van_list, {
            key: 1,
            "finished-text": _unref(t)('finished'),
            "loading-text": _unref(t)('loading'),
            loading: holdLoading.value,
            "onUpdate:loading": _cache[18] || (_cache[18] = $event => holdLoading.value = $event),
            finished: holdFinished.value,
            onLoad: holdLoad
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(holdList.value, item => {
              return _openBlock(), _createBlock(ContractItem, {
                key: item.id,
                name: item.name,
                multiple: item.multiple,
                sl: item.sl,
                tp: item.tp,
                icon: item.icon,
                status: item.status,
                side: item.side,
                type: item.type,
                time: item.time,
                "open-num": item.openNum,
                "open-price": item.openPrice,
                orderNum: item.orderNum,
                mergeKey: item.mergeKey,
                "hold-num": item.holdNum,
                last: item.last,
                margin: item.margin,
                warrant: item.warrant,
                fee: item.fee,
                onShowFutureChild: showFutureChild,
                profit: item.profit,
                id: item.id,
                close: item.close,
                "last-text": _unref(t)('unwindPrice'),
                "close-time": item.closeTime,
                index: 2
              }, null, 8, ["name", "multiple", "sl", "tp", "icon", "status", "side", "type", "time", "open-num", "open-price", "orderNum", "mergeKey", "hold-num", "last", "margin", "warrant", "fee", "profit", "id", "close", "last-text", "close-time"]);
            }), 128))]),
            _: 1
          }, 8, ["finished-text", "loading-text", "loading", "finished"])) : (_openBlock(), _createBlock(_component_van_empty, {
            key: 2,
            description: _unref(t)('nothing')
          }, null, 8, ["description"]))])]),
          _: 1
        }, 8, ["tab-list"])]),
        _: 1
      }, 8, ["modelValue", "pulling-text", "loosing-text", "loading-text", "disabled"])]), _createVNode(CustomPopupList, {
        "c-show": contractShow.value,
        title: _unref(t)('contract'),
        onHide: _cache[22] || (_cache[22] = () => {
          contractShow.value = false;
        })
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_a_input, {
          value: searchValue.value,
          "onUpdate:value": _cache[21] || (_cache[21] = $event => searchValue.value = $event),
          placeholder: _unref(t)('selectText'),
          "enter-button": "",
          allowClear: ""
        }, {
          prefix: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
          _: 1
        }, 8, ["value", "placeholder"])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coinArr), (item, key) => {
          return _openBlock(), _createBlock(TradeProductItem, {
            key: key,
            name: item,
            last: dataList.value[item] ? dataList.value[item].last : '0.00',
            icon: _unref(store).state.marketCommodities[item].icon,
            up: dataList.value[item] ? dataList.value[item].up : false,
            onClick: $event => {
              contractKey.value = item;
              contractShow.value = false;
            }
          }, null, 8, ["name", "last", "icon", "up", "onClick"]);
        }), 128))]),
        _: 1
      }, 8, ["c-show", "title"]), _createVNode(_component_van_action_sheet, {
        show: multiplShow.value,
        "onUpdate:show": _cache[23] || (_cache[23] = $event => multiplShow.value = $event),
        actions: multiple,
        "cancel-text": _unref(t)('cancelText'),
        onSelect: _cache[24] || (_cache[24] = (action, index) => {
          multipleIndex.value = index, multiplShow.value = false;
        })
      }, null, 8, ["show", "cancel-text"]), _createVNode(_component_van_popup, {
        show: setShow.value,
        "onUpdate:show": _cache[28] || (_cache[28] = $event => setShow.value = $event),
        position: "bottom",
        round: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, _toDisplayString(_unref(t)('setSlTp')), 1), _createElementVNode("div", {
          class: "close",
          onClick: _cache[25] || (_cache[25] = $event => setShow.value = false)
        }, _toDisplayString(_unref(t)('cancelText')), 1)]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_a_input, {
          class: "custom-a-input",
          value: uProfit.value,
          "onUpdate:value": _cache[26] || (_cache[26] = $event => uProfit.value = $event),
          style: {
            "width": "48%"
          },
          type: "number",
          placeholder: _unref(t)('tpPrice')
        }, null, 8, ["value", "placeholder"]), _createVNode(_component_a_input, {
          class: "custom-a-input",
          value: uDeficit.value,
          "onUpdate:value": _cache[27] || (_cache[27] = $event => uDeficit.value = $event),
          style: {
            "width": "48%",
            "margin": "8px 0"
          },
          placeholder: _unref(t)('slPrice'),
          type: "number"
        }, null, 8, ["value", "placeholder"])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_van_button, {
          color: "#F08504",
          block: "",
          loading: setLoading.value,
          onClick: setProfit,
          style: {
            "--van-button-default-height": "42px",
            "--van-button-border-radius": "4px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('setting')), 1)]),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_popup, {
        show: setShow1.value,
        "onUpdate:show": _cache[32] || (_cache[32] = $event => setShow1.value = $event),
        position: "bottom",
        round: ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, _toDisplayString(_unref(t)('closeOrder')), 1), _createElementVNode("div", {
          class: "close",
          onClick: _cache[29] || (_cache[29] = $event => setShow1.value = false)
        }, _toDisplayString(_unref(t)('cancelText')), 1)]), _createElementVNode("div", _hoisted_34, [_createVNode(_component_a_input, {
          class: "custom-a-input",
          value: amount.value,
          "onUpdate:value": _cache[30] || (_cache[30] = $event => amount.value = $event),
          style: {
            "width": "100%"
          },
          type: "number",
          placeholder: _unref(t)('money')
        }, null, 8, ["value", "placeholder"]), _createElementVNode("div", {
          style: {
            "margin-left": "10px",
            "font-size": "16px",
            "color": "#0173E5"
          },
          onClick: _cache[31] || (_cache[31] = $event => amount.value = all.value)
        }, _toDisplayString(_unref(t)('all')), 1)]), _createElementVNode("div", _hoisted_35, [_createVNode(_component_van_button, {
          color: "#F08504",
          block: "",
          loading: setLoading1.value,
          onClick: closeOrder,
          style: {
            "--van-button-default-height": "42px",
            "--van-button-border-radius": "4px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('confirmText')), 1)]),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_a_modal, {
        visible: isShowFutureChild.value,
        "onUpdate:visible": _cache[33] || (_cache[33] = $event => isShowFutureChild.value = $event),
        footer: null,
        centered: "",
        width: "90%"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(futureChildList.value, item => {
          return _openBlock(), _createBlock(ContractItem, {
            key: item.id,
            name: item.name,
            multiple: item.multiple,
            sl: item.sl,
            tp: item.tp,
            status: 4,
            side: item.side,
            type: item.type,
            time: item.time,
            "open-num": item.openNum,
            "open-price": item.openPrice,
            "hold-num": item.holdNum,
            last: dataList.value[item.symbol] ? dataList.value[item.symbol].last : '--',
            margin: item.margin,
            close: item.close,
            mergeKey: item.mergeKey,
            orderNum: item.orderNum,
            warrant: item.warrant,
            fee: item.fee,
            profit: item.profit,
            id: item.id,
            onInit: pageInit,
            onSet: setEmit,
            "last-text": _unref(t)('lastPrice')
          }, null, 8, ["name", "multiple", "sl", "tp", "side", "type", "time", "open-num", "open-price", "hold-num", "last", "margin", "close", "mergeKey", "orderNum", "warrant", "fee", "profit", "id", "last-text"]);
        }), 128)), futureChildList.value.length == 0 ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          description: _unref(t)('nothing')
        }, null, 8, ["description"])) : _createCommentVNode("", true)])]),
        _: 1
      }, 8, ["visible"])], 64);
    };
  }

};